import React, {useEffect, useState} from 'react';
import useSWRImmutable from "swr/immutable";
import {get, post} from "../../../api";
import {FiExternalLink, FiMail, FiPhone, FiUser, FiX} from "react-icons/fi";
import Select from "../../cmp/form/Select";
import StyledButton from "../../cmp/themed/StyledButton";
import Modal from "../../cmp/Modal";
import {FormattedMessage} from "react-intl";
import Checkbox from "../../cmp/form/Checkbox";
import useToggle from "../../cmp/hooks/useToggle";
import FormGroup from "../../cmp/form/FormGroup";
import Input from "../../cmp/form/Input";
import CountrySelector from "../../auth/components/CountrySelector";
import {useDispatch, useSelector} from "react-redux";
import {useNavigate, useParams} from "react-router-dom";
import BackButton from "../../cmp/BackButton";
import {actionMergeSetting} from "../../../redux/settings/settingsAction";
import PhoneInput from "../../cmp/form/phone/LazyPhoneInput";

function FreeGiftRedeem(props) {
    //@ts-ignore
    const availableGifts = useSelector((state)=>state.settings.gifts)
    const {id} = useParams()
    const gift = availableGifts.find((i)=>i.id === id)
    return (
        <div>
            <BackButton/>
            <RedeemPage gift={gift}/>
        </div>
    );
}
function RedeemPage({gift}:{gift: GiftObject}){
    //@ts-ignore
    const {data, isLoading} = useSWRImmutable('/seeding/contact_information', get)
    const address = data?.address || {}
    const [customer, setCustomer] = useState({
        first_name: '',
        last_name: '',
        email: '',
        phone:'',
    });
    const onCustomerChange = (name)=>value=>{
        setCustomer((prev)=>({
            ...prev,
            [name]: value
        }))
    }
    const onAddressChange = (name)=>value=>{
        setAddress((prev)=>({
            ...prev,
            [name]: value
        }))
    }
    useEffect(() => {
        setCustomer({
            first_name: data?.first_name,
            last_name: data?.last_name,
            email: data?.email,
            phone: data?.phone,
        })
        setAddress(
            {
                address1: address?.address1,
                address2: address?.address2,
                city: address?.city,
                province: address?.province,
                zip: address?.zip,
                country: address?.country
            }
        )
    }, [data]);
    const [addressObj, setAddress] = useState({
        address1: '',
        address2: '',
        city: '',
        province: '',
        zip: '',
        country: ''
    })
    const needsSelection = gift.maxProducts && Number(gift.maxProducts) < gift.products.length
    useEffect(() => {
        if(needsSelection){
            setSelectedProducts([])
        }else{
            setSelectedProducts(gift.products.map((i)=>i._id))
        }
    }, [needsSelection, gift]);
    const [selectedVariations, setSelectedVariations] = useState({})
    const [selectedProducts, setSelectedProducts] = useState<string[]>([])
    const isAnyQuantityMoreThanOne = gift.products.some((i)=>i.quantity > 1)
    const toggleSelectedProduct = (id)=>()=>{
        setSelectedProducts((prev)=> {
            if(prev.includes(id)){
                return prev.filter((i)=>i !== id).slice(0, Number(gift.maxProducts))
            }else{
                return [...prev, id].slice(0, Number(gift.maxProducts))
            }
        })
    }
    const canRedeem = () => {
        const errors: string[] = [];
        if (selectedProducts.length === 0) errors.push('Please choose products to redeem');
        else if (needsSelection && selectedProducts.length < Number(gift.maxProducts)) errors.push('Please choose more products to redeem');
        if (!customer.first_name) errors.push('Please enter first name');
        if (!customer.last_name) errors.push('Please enter last name');
        if (!customer.email) errors.push('Please enter email');
        if(!customer.phone) errors.push('Please enter phone');
         if (!addressObj.address1) errors.push('Please enter address');
        if (!addressObj.city) errors.push('Please enter city');
        if (!addressObj.country) errors.push('Please enter country');
        if (!addressObj.zip) errors.push('Please enter postal code');
        return errors;
    }
    const errors = canRedeem()
    const [redeeming, setRedeeming] = useState(false);
    const [orderDetails, setOrderCompleted] = useState(null)
    const navigate = useNavigate()
    const dispatch = useDispatch()
    const redeem = ()=>{
        setRedeeming(true)
        post('/seeding/redeem', {
            giftId: gift.id,
            shippingAddress: addressObj,
            customer: customer,
            selectedProducts: selectedProducts,
            selectedVariations: selectedVariations
        })
        .then((data)=>{
            setRedeeming(false)
            if(data.error){
                alert(data.error)
            }else {
                const {statusPageUrl, name, metadata} = data;
                dispatch(actionMergeSetting({metadata: JSON.stringify(metadata)}))
                navigate(`/gift/success/${gift.id}`)
            }
        })
    }
    //@ts-ignore
    const website = useSelector((state)=>state.settings.website)
    return <div>
        <h3>
            {gift.title}
        </h3>
        <div className="row g-2 mb-2">
            <div className="col-md-6">
                <div className="card">
                    <div className="pt-2 ps-3">
                        <div className="d-flex align-items-center justify-content-between">
                            <div className="card-title">Product Information</div>
                            {
                                selectedProducts.length > 0 ?
                                    <ProductChooser selectedProducts={selectedProducts}
                                                    onChange={toggleSelectedProduct} gift={gift}/> : null
                            }
                        </div>
                    </div>
                    <div className={`card-body text-center ${selectedProducts.length > 0 ? 'd-none' : ''}`}>
                        <div className="text-muted">Please choose products to redeem</div>
                        <ProductChooser selectedProducts={selectedProducts}
                                        onChange={toggleSelectedProduct} gift={gift}/>
                    </div>
                    <ul className="list-group list-group-flush">
                        {
                            selectedProducts.map((id) => {

                                const i = gift.products.find((i) => i._id === id)
                                if (!i) return null;
                                const url = `https://${website}/products/${i.handle}`;
                                const image = i.images && i.images[0] && i.images[0].url
                                const chosenVariation = i.variationOption === "any" ? selectedVariations[i._id] : i.variationOption;
                                return <div key={i._id}
                                            className={"list-group-item d-flex position-relative space-between py-3"}>
                                    {
                                        needsSelection ?
                                            <button
                                                onClick={() => setSelectedProducts((prev) => prev.filter((i) => i !== id))}
                                                className={"position-absolute btn"}
                                                style={{top: 0, right: 0}}><FiX/></button> : null
                                    }
                                    <div className="d-flex align-items-start gap-2">
                                        <img src={image} alt={""}
                                             className={"rounded border shadow-sm"}
                                             style={{width: 64, height: 64, objectFit: 'cover'}}/>
                                        <div>
                                            <div className={"mb-0"}>{i.name}</div>
                                            <small className={"free_gift_product_url"}><a href={url}
                                                      target={"_blank"}
                                                      className={"text-sm d-inline-flex align-items-center gap-1 text-decoration-underline"}>View
                                                details <FiExternalLink/></a></small>
                                            <div className="mt-2">
                                                {
                                                    isAnyQuantityMoreThanOne ?
                                                        <div>
                                                            <span className={"text-muted"}>Quantity: {i.quantity}</span>
                                                        </div> : null
                                                }
                                                {
                                                    i.variationOption === "any" && i.variations.length > 1 ?
                                                        <div style={{width: '200px'}}>
                                                            <Select
                                                                defaultSelectFirst
                                                                value={selectedVariations[i._id]}
                                                                onChange={(value) => {
                                                                    setSelectedVariations((prev) => ({
                                                                        ...prev,
                                                                        [i._id]: value
                                                                    }))
                                                                }}
                                                                options={i.variations.map((i) => {
                                                                    return {
                                                                        value: i.id,
                                                                        label: i.name
                                                                    }
                                                                })}/>
                                                        </div>
                                                        : <span>{
                                                            i.variations.find((i) => i.id === chosenVariation)?.name
                                                        }</span>
                                                }
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            })
                        }
                    </ul>
                </div>
            </div>
            <div className="col-md-6">
                <div className="card">
                    <ContactInformation data={customer} onChange={onCustomerChange}/>
                </div>
                <div className="card mt-2">
                    <ShippingAddress address={addressObj} onChange={onAddressChange}/>
                </div>
            </div>
        </div>

        {
            !isLoading && errors.length > 0 ? <div className="mt-2 alert alert-warning">
                <ol className={"mb-0"}>
                    {
                        errors.map((i, index) => {
                            return <li key={index}>{i}</li>
                        })
                    }
                </ol>
            </div> : <div className="text-center"><StyledButton
                onClick={redeem}
                loading={redeeming}
                disabled={errors.length > 0}>Redeem</StyledButton>
            </div>
        }
    </div>
}

function ProductSelectorModal({visible, gift, toggle, selectedProducts, onChange}) {
    const isAnyQuantityMoreThanOne = gift.products.some((i) => i.quantity > 1)
    //@ts-ignore
    const website = useSelector((state) => state.settings.website)
    const hasAllSelected = gift.maxProducts && selectedProducts.length >= Number(gift.maxProducts)
    return <Modal
        title={"Choose Products"}
        visible={visible} onClose={toggle}>
        <p><FormattedMessage id={"free_gift_choose"}
                             defaultMessage={`Choose {num, plural, one {a free product} other {{num} free products}}`}
                             values={{
                                 num: gift.maxProducts
                             }}/>
        </p>
        <ul className="list-group list-group-flush">
            {
                gift.products.map((i) => {
                    const url = `https://${website}/products/${i.handle}`;
                    const isSelected = selectedProducts.includes(i._id)
                    const isHalfOpacity = !isSelected && hasAllSelected
                    return <li className={`list-group-item py-3
               space-between 
               ${isHalfOpacity ? `opacity-50` : `list-group-item-action`}`}
                               onClick={onChange(i._id)}>
                        <div className="d-flex align-items-start gap-2">
                            <img src={i.images[0]?.url} alt={""}
                                 className={"rounded border shadow-sm"}
                                 style={{width: 64, height: 64, objectFit: 'cover'}}/>
                            <div>
                                <div className={"mb-0"}>{i.name}</div>
                                <small><a href={url}
                                          target={"_blank"}
                                          onClick={(e) => {
                                              e.stopPropagation();
                                          }}
                                          className={"text-sm d-inline-flex align-items-center gap-1 text-decoration-underline"}>View
                                    details <FiExternalLink/></a></small>
                                <div className="mt-2">
                                    {
                                        isAnyQuantityMoreThanOne ?
                                            <div>
                                                <span className={"text-muted"}>Quantity: {i.quantity}</span>
                                            </div> : null
                                    }
                                </div>
                            </div>
                        </div>
                        <Checkbox checked={isSelected}/>
                    </li>
                })
            }
        </ul>
    </Modal>
}

function ProductChooser({selectedProducts, gift, onChange}) {
    const [visible, toggle] = useToggle();
    const needsSelection = gift.maxProducts && Number(gift.maxProducts) < gift.products.length
    if (!needsSelection) return null
    return <>
        <button onClick={toggle} className="btn btn-link btn-sm">Choose products</button>
        <ProductSelectorModal visible={visible} toggle={toggle}
                              selectedProducts={selectedProducts}
                              gift={gift} onChange={onChange}
        />
    </>
}

function ShippingAddress({address, onChange}) {
    const [visible, toggle] = useToggle()
    return <React.Fragment>
        <div className="card-body">
            <div className="d-flex align-items-center justify-content-between">
                <div className="card-title">Shipping Address</div>
                <button onClick={toggle} className={"btn btn-link btn-sm"}>Edit</button>
            </div>
            <div>
                {address?.address1} {address?.address2}<br/>
                {address?.city}, {address?.province}, {address?.zip}<br/>
                {address?.country}
            </div>
        </div>
        <Modal visible={visible} onClose={toggle} title={"Shipping Address"}>
            <FormGroup label={"Address Line 1"} required>
                <Input value={address?.address1} onChange={onChange('address1')}/>
            </FormGroup>
            <FormGroup label={"Address Line 2"}>
                <Input value={address?.address2} onChange={onChange('address2')}/>
            </FormGroup>
            <div className="row">
                <div className="col-md-6">
                    <FormGroup label={"City"} required>
                        <Input value={address?.city} onChange={onChange('city')}/>
                    </FormGroup>
                </div>
                <div className="col-md-6">
                    <FormGroup label={"Province"}>
                        <Input value={address?.province} onChange={onChange('province')}/>
                    </FormGroup>

                </div>
            </div>
            <div className="row">
                <div className="col-md-6">
                    <FormGroup label={"Country"} required>
                        <CountrySelector value={address?.country} onChange={(e)=> {
                            onChange('country')(e.target.value)
                        }}/>
                    </FormGroup>
                </div>
                <div className="col-md-6">
                    <FormGroup label={"Postal Code"} required>
                        <Input value={address?.zip} onChange={onChange('zip')}/>
                    </FormGroup>

                </div>
            </div>
        </Modal>
    </React.Fragment>
}


function ContactInformation({data, onChange}) {
    const [visible, toggle] = useToggle()
    return <React.Fragment>
        <div className="card-body">
            <div className="d-flex align-items-center justify-content-between">
                <div className="card-title">Contact Information</div>
                <button onClick={toggle} className={"btn btn-link btn-sm"}>Edit</button>
            </div>
            <div className="d-flex align-items-center gap-2">
                <FiUser/> <span>{data?.first_name} {data?.last_name}</span>
            </div>
            <div className="d-flex align-items-center gap-2">
                <FiMail/> <span>{data?.email}</span>
            </div>
            <div className="d-flex align-items-center gap-2">
                <FiPhone/> <span>{data?.phone}</span>
            </div>
        </div>
        <Modal visible={visible} title={"Contact Information"}
               onClose={toggle}
                onOk={toggle}
               okText={"Submit"}
        >
            <div className="row">
                <div className="col-md-6">
                    <FormGroup label={"First Name"}>
                        <Input value={data?.first_name} onChange={onChange('first_name')}/>
                    </FormGroup>
                </div>
                <div className="col-md-6">
                    <FormGroup label={"Last Name"}>
                        <Input value={data?.last_name} onChange={onChange('last_name')}/>
                    </FormGroup>
                </div>
            </div>
            <FormGroup label={"Email address"}>
                <Input value={data?.email} onChange={onChange('email')} prefix={<FiMail/>}/>
            </FormGroup>
            <FormGroup label={"Phone"}>
                <PhoneInput value={data?.phone} onChange={(e)=>onChange('phone')(e.target.value)}/>
            </FormGroup>
        </Modal>
    </React.Fragment>
}

export default FreeGiftRedeem;
